module.exports = __webpack_public_path__ + "img/accessories.4f5ddde0.svg";